export default __webpack_public_path__ + "static/media/lc-icon-active.0ab206b6.webp";